<template>
  <div class="member-info-card">
    <h5 class="cs-textstyle-item-heading" v-if="cardTitle">{{ cardTitle }}</h5>
    <div class="card">
      <div
        class="picture"
        :style="{ backgroundImage: `url(${member.photo_url})` }"
      >
        <img class="sr-only" :src="member.photo_url" :alt="member.name" />
      </div>
      <div class="content">
        <h3 class="cs-textstyle-paragraph-small-bold">{{ member.name }}</h3>
        <h6 v-if="member.headline" class="cs-textstyle-paragraph-small">
          {{ member.headline }}
        </h6>
        <div class="social-media-links">
          <a
            :href="member.linkedin_url"
            v-if="member.linkedin_url"
            target="_blank"
          >
            <i class="cs-icons-linkedin-filled"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'member-info-card',

  props: {
    cardTitle: {
      type: String,
      default: ''
    },
    member: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: row;
  padding: 0;
}

h3 {
  font-weight: 700;
  margin-bottom: 5px;
}

.picture {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  background-color: $grey;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  overflow: hidden;
  margin-right: 10px;
}

.content {
  width: 75%;
  h3,
  h6 {
    color: var(--cs-gray-05);
    text-transform: none;
  }
  p {
    margin-bottom: 0;
    font-size: 15px;
    color: #505b64;
    line-height: 21px;
  }

  i {
    color: $grey-icon;
    font-size: 20px;

    &:hover {
      color: $secondary;
    }
  }
  a {
    margin-right: 10px;
  }
}
</style>
